const setProductPopupImage = (triggerButton) => {
	const popupImage = document.querySelector('.js-popup-single-image')
	const popupImageContainer = document.querySelector('.product-media-modal__image-container')
	if (!popupImage || !triggerButton) return
	const requestToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`
	popupImage.dataset.popupRequestToken = requestToken

	const isLatestRequest = () => popupImage.dataset.popupRequestToken === requestToken

	const setPopupLoadingState = (isLoading) => {
		if (!popupImageContainer || !isLatestRequest()) return
		popupImageContainer.classList.toggle('is-loading', isLoading)
	}
	setPopupLoadingState(true)

	const getBestImageFromContext = () => {
		const productOuter = triggerButton.closest('.product__outer')
		const activeMediaImage = productOuter
			? productOuter.querySelector('.product__media-item.active .product__media img')
			: null
		const visibleMediaImage = productOuter
			? productOuter.querySelector(
					'.product__media-item.product__media-item--visible .product__media img',
				)
			: null
		const openerMediaImage = triggerButton
			.closest('.product__modal-opener')
			?.querySelector('.product__media img')
		return activeMediaImage || visibleMediaImage || openerMediaImage || null
	}

	const normalizeImageSrc = (src) => {
		let normalizedSrc = (src || '').replace(/&amp;/g, '&').trim()
		if (!normalizedSrc) return ''
		if (normalizedSrc.startsWith('//')) {
			normalizedSrc = `${window.location.protocol}${normalizedSrc}`
		}
		return normalizedSrc
	}

	const toComparableSrc = (src) => {
		const normalizedSrc = normalizeImageSrc(src)
		if (!normalizedSrc) return ''
		try {
			const parsedUrl = new URL(normalizedSrc, window.location.origin)
			return `${parsedUrl.pathname}${parsedUrl.search}`
		} catch {
			return normalizedSrc
		}
	}

	const hideSkeletonWhenReady = (targetSrc) => {
		if (!targetSrc) {
			setPopupLoadingState(false)
			return
		}
		const targetComparableSrc = toComparableSrc(targetSrc)
		const isTargetLoaded = () => {
			const currentComparableSrc = toComparableSrc(
				popupImage.currentSrc || popupImage.getAttribute('src') || '',
			)
			return (
				popupImage.complete &&
				popupImage.naturalWidth > 0 &&
				targetComparableSrc &&
				currentComparableSrc === targetComparableSrc
			)
		}

		if (isTargetLoaded()) {
			setPopupLoadingState(false)
			return
		}

		const onLoaded = () => {
			if (!isLatestRequest()) return
			if (isTargetLoaded()) {
				setPopupLoadingState(false)
			}
		}
		const onErrored = () => {
			if (!isLatestRequest()) return
			setPopupLoadingState(false)
		}

		popupImage.addEventListener('load', onLoaded, { once: true })
		popupImage.addEventListener('error', onErrored, { once: true })
	}

	const resolveImageData = () => {
		const sourceImage = getBestImageFromContext()
		const rawSrcset = sourceImage?.getAttribute('srcset') || ''
		const firstSrcsetCandidate = rawSrcset ? rawSrcset.split(',')[0].trim().split(' ')[0] : ''
		const popupSrc = normalizeImageSrc(triggerButton.dataset.popupImage?.trim() || '')
		const galleryCurrentSrc = normalizeImageSrc(sourceImage?.currentSrc || '')
		const galleryAttrSrc = normalizeImageSrc(sourceImage?.getAttribute('src') || '')
		const gallerySrcsetSrc = normalizeImageSrc(firstSrcsetCandidate)
		const gallerySrc = galleryCurrentSrc || galleryAttrSrc || gallerySrcsetSrc || ''
		let resolvedSrc = gallerySrc || popupSrc || ''
		const resolvedAlt =
			sourceImage?.getAttribute('alt') ||
			triggerButton.dataset.popupAlt ||
			popupImage.getAttribute('alt')

		resolvedSrc = normalizeImageSrc(resolvedSrc)

		return { src: resolvedSrc, alt: resolvedAlt, popupSrc }
	}

	const applyResolvedImage = () => {
		const resolvedImage = resolveImageData()
		if (!resolvedImage.src) {
			setPopupLoadingState(false)
			return
		}
		popupImage.setAttribute('src', resolvedImage.src)
		if (resolvedImage.alt) popupImage.setAttribute('alt', resolvedImage.alt)
		const hasHighResUpgrade =
			resolvedImage.popupSrc &&
			toComparableSrc(resolvedImage.popupSrc) !== toComparableSrc(resolvedImage.src)
		if (hasHighResUpgrade) {
			const upgradeToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`
			popupImage.dataset.popupUpgradeToken = upgradeToken
			const highResImage = new Image()
			highResImage.decoding = 'async'
			highResImage.onload = () => {
				if (popupImage.dataset.popupUpgradeToken !== upgradeToken || !isLatestRequest()) return
				if (
					toComparableSrc(popupImage.currentSrc || popupImage.getAttribute('src') || '') !==
					toComparableSrc(resolvedImage.popupSrc)
				) {
					popupImage.setAttribute('src', resolvedImage.popupSrc)
				}
				hideSkeletonWhenReady(resolvedImage.popupSrc)
			}
			highResImage.onerror = () => {
				if (popupImage.dataset.popupUpgradeToken !== upgradeToken || !isLatestRequest()) return
				hideSkeletonWhenReady(resolvedImage.src)
			}
			highResImage.src = resolvedImage.popupSrc
		} else {
			hideSkeletonWhenReady(resolvedImage.src)
		}
	}

	const alignPopupImageViewport = () => {
		if (!popupImageContainer) return
		popupImageContainer.scrollTop = 0
		if (window.innerWidth < 750) {
			popupImageContainer.scrollLeft = 0
			return
		}
		const horizontalOffset = Math.max(
			0,
			(popupImageContainer.scrollWidth - popupImageContainer.clientWidth) / 2,
		)
		popupImageContainer.scrollLeft = horizontalOffset
	}

	applyResolvedImage()
	if (popupImage.complete) {
		alignPopupImageViewport()
	} else {
		popupImage.addEventListener('load', () => {
			alignPopupImageViewport()
		}, { once: true })
	}
	window.requestAnimationFrame(() => {
		window.setTimeout(() => {
			applyResolvedImage()
			alignPopupImageViewport()
		}, 120)
	})
}

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list, .js-media-list-mobile') &&
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').length > 0
	) {
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').forEach((elem, index) => {
			let prevButton = elem.querySelector('.product__slider-nav .swiper-button-prev')
			let nextButton = elem.querySelector('.product__slider-nav .swiper-button-next')
			let pagination = elem.querySelector('.product__pagination')
			const initialSlide = elem.dataset.currentIndex || 0

			if (elem.swiper) {
				elem.swiper.destroy(true, true)
			}

			let slider = new Swiper(elem, {
				allowTouchMove: false,
				initialSlide: initialSlide,
				slidesPerView:
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--full_screen_top-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--single_aside-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--thumbs_aside-mobile')
						? 1
						: 1.1,
				spaceBetween: elem
					.closest('.product__outer')
					.classList.contains('product__gallery--multiple_top-mobile')
					? 0
					: 1,
				autoHeight: true,
				speed: 500,
				freeMode: {
					enabled:
						window.innerWidth < 750
							? elem
									.closest('.product__outer')
									.classList.contains('product__gallery--multiple_top-mobile')
							: elem.closest('.product__outer').classList.contains('product__outer--multiple-top'),
					sticky: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					clickable: true,
				},
				thumbs: {
					swiper: elem.nextElementSibling.querySelector('.js-media-sublist')?.swiper
						? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
						: '',
				},
				breakpoints: {
					750: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 1.1,
						spaceBetween: elem
							.closest('.product__outer')
							.classList.contains('product__outer--multiple-top')
							? 0
							: 1,
					},
					// Fixed
					990: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 2.37,
					},
				},
				on: {
					slideChangeTransitionStart: function () {
						const slider =
							document.querySelector('.js-media-list') ||
							document.querySelector('.js-media-list-mobile')
						if (
							document.querySelector('.js-media-sublist') &&
							document.querySelector('.js-media-sublist').swiper
						) {
							document.querySelector('.js-media-sublist').swiper.slideTo(slider.swiper.activeIndex)
						}
					},
					slideChange: function () {
						window.pauseAllMedia()
						this.params.noSwiping = false

						// Update visibility to show only the active item - Desktop only (above 750px)
						const isDesktop = window.innerWidth >= 750
						const mediaList = this.el.closest('.product__media-list') || this.el
						if (mediaList && isDesktop) {
							const mediaElements = Array.from(mediaList.querySelectorAll('.product__media-item'))
							const activeSlide = this.slides[this.activeIndex]
							
							// Find the media item - it could be the slide itself or a child
							let activeMediaItem = null
							if (activeSlide) {
								activeMediaItem = activeSlide.classList.contains('product__media-item') 
									? activeSlide 
									: activeSlide.querySelector('.product__media-item') || activeSlide.closest('.product__media-item')
							}
							
							if (activeMediaItem) {
								// Mark that visibility is being managed
								mediaList.classList.add('product__media-list--visibility-managed')
								
								// Remove visible class from all items
								mediaElements.forEach((element) => {
									element.classList.remove('product__media-item--visible')
									element.classList.remove('active')
								})
								
								// Add active and visible class to the current item
								activeMediaItem.classList.add('active')
								activeMediaItem.classList.add('product__media-item--visible')
							}
						}

					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							this.slides[this.activeIndex]
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							if (
								!this.slides[this.activeIndex]
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					slider.update()
				}, 800)
			}
		})

		const pageResizeObserve = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width < 750) {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (
					slider &&
					slider.swiper &&
					(entry.target.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						entry.target.querySelector('.product__gallery--static_column_aside-mobile'))
				) {
					slider.swiper.destroy(true, true)
				}

				if (sliderMobile && !slider) {
					if (!sliderMobile.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			} else {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (sliderMobile && sliderMobile.swiper && !slider) {
					sliderMobile.swiper.destroy(true, true)
				}

				if (slider) {
					if (!slider.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			}
		})

		if (document.querySelector('.product-section'))
			pageResizeObserve.observe(document.querySelector('.product-section'))
	}
}

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			if (elem.swiper) elem.swiper.destroy()
			const isThumbsAside = elem.classList.contains('sublist-thumbs-aside')

			const breakpoint = isThumbsAside ? 1100 : 990

			let subSlider = new Swiper(elem, {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: 'horizontal',
				direction: 'horizontal',
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: true,
				on: {
					afterInit: function () {
						//this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
						
						// Add click handlers to thumbnail subitems for static galleries
						const productOuter = elem.closest('.product__outer')
						const isStaticGallery = productOuter && (
							productOuter.classList.contains('product__outer--static-multicolumns-aside') || 
							productOuter.classList.contains('product__outer--static-column-aside')
						)
						
						if (isStaticGallery) {
							const subItems = elem.querySelectorAll('.product__media-subitem')
							subItems.forEach((subItem, index) => {
								subItem.addEventListener('click', function() {
									const mediaId = subItem.getAttribute('data-media-sub-id')
									if (mediaId) {
										// Extract the media ID (format: sectionId-mediaId)
										const parts = mediaId.split('-')
										const actualMediaId = parts.length > 1 ? parts[parts.length - 1] : mediaId
										
										// Find the corresponding main media item
										const mediaList = productOuter.querySelector('.product__media-list')
										if (mediaList) {
											const mainMediaItem = mediaList.querySelector(`[data-media-id="${mediaId}"]`)
											if (mainMediaItem) {
												// Update active state
												mediaList.querySelectorAll('.product__media-item').forEach((item) => {
													item.classList.remove('active')
												})
												mainMediaItem.classList.add('active')
												
												// Update visibility to show only active item - Desktop only (above 750px)
												const isDesktop = window.innerWidth >= 750
												if (isDesktop) {
													mediaList.classList.add('product__media-list--visibility-managed')
													const allMediaItems = Array.from(mediaList.querySelectorAll('.product__media-item'))
													allMediaItems.forEach((item) => {
														item.classList.remove('product__media-item--visible')
													})
													mainMediaItem.classList.add('product__media-item--visible')
												} else {
													// On mobile, show all items
													mediaList.classList.remove('product__media-list--visibility-managed')
													const allMediaItems = Array.from(mediaList.querySelectorAll('.product__media-item'))
													allMediaItems.forEach((item) => {
														item.classList.add('product__media-item--visible')
													})
												}
												
												// Update thumbnail active state
												subItems.forEach((item) => {
													item.classList.remove('active')
												})
												subItem.classList.add('active')
											}
										}
									}
								})
							})
						}
					},
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				//transitionStart: function () {
				//	document
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			document.querySelector(".js-media-sublist").swiper.activeIndex,
				//		);
				//},
				breakpoints: {
					[breakpoint]: {
						spaceBetween: 4,
						direction: 'vertical',
						slidesPerView: 'auto',
						direction: 'vertical',
						slidesPerView: 'auto',
					},
				},
			})

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries
				// Fixed
				if (entry.contentRect.width >= breakpoint) {
					setTimeout(() => {
						const sliders = document.querySelectorAll('.js-media-list, .js-media-list-mobile')
						const thumbs = document.querySelectorAll('.product__media-sublist')

						const sliderHeight = sliders[index].getBoundingClientRect().height
						thumbs[index].style.height = `${sliderHeight - 1}px`
					}, 400)
				}
			})

			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))
			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))

			document.querySelectorAll('.featured-product-section').forEach((section) => {
				sliderResizeObserve.observe(section)
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	const modalImage = document.querySelector('.js-popup-single-image')
	if (!modalImage) return

	document.querySelectorAll('.product__media-toggle').forEach((mediaToggle) => {
		if (mediaToggle.dataset.popupBound === 'true') return
		mediaToggle.dataset.popupBound = 'true'
		mediaToggle.addEventListener('click', (event) => {
			setProductPopupImage(event.currentTarget)
		})
	})
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	)
}

;(function () {
	const headerDrawer = document.querySelector('header-drawer')
	if (!headerDrawer) return

	const drawerTabs = document.querySelectorAll('.mega-menu__tab')
	if (!drawerTabs) return

	drawerTabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			tab.classList.toggle('tab--active')
			const tabToggler = tab.querySelector('.mega-menu__tab-toggler')
			const initialExpanded = JSON.parse(tabToggler.getAttribute('aria-expanded'))
			tabToggler.setAttribute('aria-expanded', `${!initialExpanded}`)
		})
	})
})()

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	if (!container) {
		return
	}
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		// For complementary products, allow going down to 0
		const isComplementary = this.input.classList.contains('complementary-quantity-input')
		if (isComplementary) {
			// Never disable minus button for complementary products (can go to 0)
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		} else {
			// For regular products, disable at 1
			if (this.input.value == 1) {
				this.querySelector('button[name="minus"]').classList.add('disabled')
			} else {
				this.querySelector('button[name="minus"]').classList.remove('disabled')
			}
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

// Complementary Products Auto-Add to Cart
class ComplementaryProductsHandler {
	constructor() {
		this.cartUpdateUnsubscriber = null
		this.init()
	}

	init() {
		// Use event delegation to handle dynamically loaded complementary products
		document.addEventListener('change', this.handleQuantityChange.bind(this))
		
		// Subscribe to cart update events to sync quantity inputs when cart changes from other sources (e.g., minicart removal)
		if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
				// Update complementary product quantity inputs when cart is updated from any source
				this.syncQuantityInputsFromCart()
			})
		}
	}

	async syncQuantityInputsFromCart() {
		try {
			// Fetch current cart state
			const cartResponse = await fetch(`${routes.cart_url}.js`)
			const cart = await cartResponse.json()
			
			// Update all complementary product quantity inputs to reflect current cart state
			document.querySelectorAll('.complementary-quantity-input').forEach((input) => {
				const variantId = parseInt(input.dataset.variantId)
				const cartItem = cart.items.find(item => item.variant_id === variantId)
				const currentCartQty = cartItem ? cartItem.quantity : 0
				
				// Update the input value and data attribute
				input.value = currentCartQty
				input.dataset.cartQuantity = currentCartQty
			})
		} catch (error) {
			console.error('Error syncing complementary product quantities:', error)
		}
	}

	async handleQuantityChange(event) {
		const input = event.target
		// Only handle complementary product quantity inputs
		if (!input.classList.contains('complementary-quantity-input')) {
			return
		}

		const variantId = input.dataset.variantId
		const productId = input.dataset.productId
		let newQuantity = parseInt(input.value) || 0
		const minQuantity = parseInt(input.dataset.min) || 1

		// Allow 0 quantity (to remove from cart), but ensure it's not negative
		if (newQuantity < 0) {
			newQuantity = 0
			input.value = 0
		}

		// If quantity is greater than 0, ensure it meets minimum requirement
		if (newQuantity > 0 && newQuantity < minQuantity) {
			newQuantity = minQuantity
			input.value = minQuantity
		}

		// Disable input during processing
		input.disabled = true
		const quantityInput = input.closest('quantity-input')
		if (quantityInput) {
			quantityInput.style.opacity = '0.6'
			quantityInput.style.pointerEvents = 'none'
		}

		try {
			// Get current cart to find existing line item
			const cartResponse = await fetch(`${routes.cart_url}.js`)
			const cart = await cartResponse.json()

			// Find existing line item by variant ID
			const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId))
			
			if (existingItem) {
				// Update existing item - find line index (1-based)
				const lineIndex = cart.items.findIndex(item => item.variant_id === parseInt(variantId)) + 1
				if (newQuantity === 0) {
					// Remove item from cart - use updateCartItem with quantity 0
					await this.updateCartItem(lineIndex, 0, variantId)
					// After removal, update the input to reflect the cart state (should be 0)
					input.value = 0
					input.dataset.cartQuantity = 0
				} else {
					// Update quantity
					await this.updateCartItem(lineIndex, newQuantity, variantId)
					// Update data-cart-quantity attribute
					input.dataset.cartQuantity = newQuantity
				}
			} else if (newQuantity > 0) {
				// Add new item (only if quantity > 0)
				await this.addToCart(variantId, newQuantity, productId)
				// Update data-cart-quantity attribute
				input.dataset.cartQuantity = newQuantity
			} else {
				// Quantity is 0 and item is not in cart - no action needed
				input.value = 0
				input.dataset.cartQuantity = 0
			}
			
			// Don't publish cart update event immediately - it causes conflicts
			// The updateCartItem/addToCart methods already handle updating the drawer
			// Publishing the event triggers onCartUpdate which only updates items, breaking the header

		} catch (error) {
			console.error('Error updating complementary product:', error)
			// Revert to previous value on error
			const previousQuantity = input.dataset.cartQuantity || 0
			input.value = previousQuantity
		} finally {
			// Re-enable input
			input.disabled = false
			if (quantityInput) {
				quantityInput.style.opacity = '1'
				quantityInput.style.pointerEvents = 'auto'
			}
		}
	}

	async addToCart(variantId, quantity, productId) {
		const config = fetchConfig('javascript')
		config.headers['X-Requested-With'] = 'XMLHttpRequest'
		delete config.headers['Content-Type']

		const formData = new FormData()
		formData.append('id', variantId)
		formData.append('quantity', quantity)

		const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
		if (cart) {
			formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','))
			formData.append('sections_url', window.location.pathname)
		}

		config.body = formData

		const response = await fetch(`${routes.cart_add_url}`, config)
		const result = await response.json()

		if (result.status) {
			throw new Error(result.description || 'Failed to add to cart')
		}

		// Update cart UI if cart element exists
		if (cart && typeof cart.renderContents === 'function') {
			// renderContents already handles updating the drawer with correct sections
			cart.renderContents(result)
		} else {
			// If no cart drawer/notification, still update cart icon
			if (result.sections && result.sections['cart-icon-bubble']) {
				const cartIconBubble = document.getElementById('cart-icon-bubble')
				if (cartIconBubble) {
					const parser = new DOMParser()
					const doc = parser.parseFromString(result.sections['cart-icon-bubble'], 'text/html')
					const newContent = doc.querySelector('.shopify-section')
					if (newContent) {
						cartIconBubble.innerHTML = newContent.innerHTML
					}
				}
			}
		}

		// DO NOT publish cartUpdate event - it triggers onCartUpdate() which only updates items list
		// and breaks the drawer header. renderContents() already updated everything correctly.

		// Update all complementary product quantity inputs to reflect current cart state
		if (result.items) {
			document.querySelectorAll('.complementary-quantity-input').forEach((input) => {
				const variantId = parseInt(input.dataset.variantId)
				const cartItem = result.items.find(item => item.variant_id === variantId)
				const currentCartQty = cartItem ? cartItem.quantity : 0
				
				// Update the input value and data attribute
				input.value = currentCartQty
				input.dataset.cartQuantity = currentCartQty
			})
		}

		return result
	}

	async updateCartItem(lineIndex, quantity, variantId) {
		const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items')
		const cartDrawer = document.querySelector('cart-drawer')
		
		// Get sections to render - use section.section for cart-change API
		const sectionsToRender = []
		if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
			sectionsToRender.push(...cartItems.getSectionsToRender().map((section) => section.section))
		}
		// Also include cart-drawer and cart-icon-bubble if cart drawer exists
		if (cartDrawer) {
			if (!sectionsToRender.includes('cart-drawer')) sectionsToRender.push('cart-drawer')
			if (!sectionsToRender.includes('cart-icon-bubble')) sectionsToRender.push('cart-icon-bubble')
		}

		const body = JSON.stringify({
			line: lineIndex,
			quantity: quantity,
			sections: sectionsToRender,
			sections_url: window.location.pathname
		})

		const response = await fetch(`${routes.cart_change_url}`, {
			...fetchConfig(),
			...{ body }
		})

		const result = await response.text()
		const parsedResult = JSON.parse(result)

		if (parsedResult.errors) {
			throw new Error(parsedResult.errors)
		}

		// Update cart items UI (same pattern as cart.js)
		if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
			// Toggle empty state
			cartItems.classList.toggle('is-empty', parsedResult.item_count === 0)
			
			// Update cart drawer empty state
			if (cartDrawer) {
				cartDrawer.classList.toggle('is-empty', parsedResult.item_count === 0)
				const drawerInner = cartDrawer.querySelector('.drawer__inner')
				if (drawerInner) {
					drawerInner.classList.toggle('is-empty', parsedResult.item_count === 0)
				}
			}

			// Update cart footer empty state
			const cartFooter = document.getElementById('main-cart-footer')
			if (cartFooter) {
				cartFooter.classList.toggle('is-empty', parsedResult.item_count === 0)
			}

			// Update sections using the same pattern as cart.js
			cartItems.getSectionsToRender().forEach((section) => {
				const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id)
				if (elementToReplace && parsedResult.sections && parsedResult.sections[section.section]) {
					elementToReplace.innerHTML = cartItems.getSectionInnerHTML(parsedResult.sections[section.section], section.selector)
				}
			})
		}

		// Update cart drawer header and icon bubble
		// The cart-change API returns sections keyed by section name (section.section)
		if (cartDrawer && parsedResult.sections) {
			// Update cart-drawer section (contains the header with item count)
			if (parsedResult.sections['cart-drawer']) {
				const cartDrawerElement = document.getElementById('CartDrawer')
				if (cartDrawerElement) {
					// Parse the HTML and extract the CartDrawer content
					const parser = new DOMParser()
					const doc = parser.parseFromString(parsedResult.sections['cart-drawer'], 'text/html')
					const newCartDrawer = doc.querySelector('#CartDrawer')
					if (newCartDrawer) {
						// Replace the entire CartDrawer content
						cartDrawerElement.innerHTML = newCartDrawer.innerHTML
					}
				}
			}

			// Update cart-icon-bubble
			if (parsedResult.sections['cart-icon-bubble']) {
				const cartIconBubble = document.getElementById('cart-icon-bubble')
				if (cartIconBubble) {
					const parser = new DOMParser()
					const doc = parser.parseFromString(parsedResult.sections['cart-icon-bubble'], 'text/html')
					const newContent = doc.querySelector('.shopify-section')
					if (newContent) {
						cartIconBubble.innerHTML = newContent.innerHTML
					}
				}
			}
		}

		// Don't publish cart update event - it triggers onCartUpdate which only updates items list
		// and breaks the header. We've already updated everything correctly above.

		// Update all complementary product quantity inputs to reflect current cart state
		// This ensures that if an item was removed, all quantity boxes show the correct value
		if (parsedResult.item_count !== undefined) {
			// Fetch current cart to get updated quantities
			const updatedCartResponse = await fetch(`${routes.cart_url}.js`)
			const updatedCart = await updatedCartResponse.json()
			
			// Update all complementary product quantity inputs
			document.querySelectorAll('.complementary-quantity-input').forEach((input) => {
				const variantId = parseInt(input.dataset.variantId)
				const cartItem = updatedCart.items.find(item => item.variant_id === variantId)
				const currentCartQty = cartItem ? cartItem.quantity : 0
				
				// Update the input value and data attribute
				input.value = currentCartQty
				input.dataset.cartQuantity = currentCartQty
			})
		}

		return parsedResult
	}
}

// Initialize complementary products handler when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new ComplementaryProductsHandler()
	})
} else {
	new ComplementaryProductsHandler()
}

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button) return
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
				
				// Scroll mobile-facets__inner to top when submenu opens
				const submenu = detailsElement.querySelector('.mobile-facets__submenu')
				if (submenu) {
					const mobileFacetsInner = document.querySelector('.mobile-facets__inner')
					if (mobileFacetsInner) {
						mobileFacetsInner.scrollTop = 0
					}
				}
			})
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		
		// Ensure all menu items are visible when opening
		this.mainDetailsToggle.querySelectorAll('.menu-drawer__menu-item').forEach((item) => {
			item.style.visibility = 'visible'
			item.style.opacity = '1'
		})
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header = this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.add('color-background-1', 'color-background-3')
			}
			if (
				this.header.classList.contains('color-background-1') &&
				!this.header.classList.contains('shopify-section-header-sticky')
			) {
				this.header.classList.add('color-background-3')
			}
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				if (this.classList.contains('mobile-facets__wrapper')) this.closeMenuDrawer()
				else this.closeMenuDrawer(event)
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector('.shopify-section-header')
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		)

		if (
			this.header.classList.contains('color-background-3') &&
			!this.header.classList.contains('shopify-section-header-sticky')
		) {
			this.header.classList.remove('color-background-3')
		}

		const main = document.querySelector('main')
		if (main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay')) {
			this.header.classList.remove('color-background-3')
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		
		// Ensure all menu items are visible when opening
		this.mainDetailsToggle.querySelectorAll('.menu-drawer__menu-item').forEach((item) => {
			item.style.visibility = 'visible'
			item.style.opacity = '1'
		})
	}
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) {
				if (modal.classList.contains('product-media-modal') && typeof setProductPopupImage === 'function') {
					setProductPopupImage(button)
				}
				modal.show(button)
			}
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this),
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
		this.previousPrintType = null
		this.isUpdating = false
	}

	/**
	 * Get Frame Color value from either select dropdown or radio buttons
	 * @returns {string|null} The selected Frame Color value or null
	 */
	getFrameColorValue() {
		// First try to find a select with name containing "Frame Color", "Frame Colour", or French "Couleur du cadre"/"Couleur de cadre"
		const frameColorSelect = this.querySelector('select[name*="Frame Color"], select[name*="Frame Colour"], select[name*="Couleur du cadre"], select[name*="Couleur de cadre"]')
		if (frameColorSelect) {
			return frameColorSelect.value || null
		}
		
		// If no select found, try to find checked radio button
		const frameColorRadio = this.querySelector('input[type="radio"][name*="Frame Color"]:checked, input[type="radio"][name*="Frame Colour"]:checked, input[type="radio"][name*="Couleur du cadre"]:checked, input[type="radio"][name*="Couleur de cadre"]:checked')
		if (frameColorRadio) {
			return frameColorRadio.value || null
		}
		
		// Fallback: try by position (3rd select)
		const selects = this.querySelectorAll('select')
		if (selects.length >= 3) {
			return selects[2].value || null
		}
		
		return null
	}

	/**
	 * Get Frame Color input element (select or radio)
	 * @returns {HTMLElement|null} The Frame Color input element or null
	 */
	getFrameColorInput() {
		// First try to find a select with name containing "Frame Color", "Frame Colour", or French "Couleur du cadre"/"Couleur de cadre"
		const frameColorSelect = this.querySelector('select[name*="Frame Color"], select[name*="Frame Colour"], select[name*="Couleur du cadre"], select[name*="Couleur de cadre"]')
		if (frameColorSelect) {
			return frameColorSelect
		}
		
		// If no select found, try to find the fieldset and return the first radio
		const frameColorFieldset = this.querySelector('fieldset.product-form__controls:has(input[type="radio"][name*="Frame Color"]), fieldset.product-form__controls:has(input[type="radio"][name*="Frame Colour"]), fieldset.product-form__controls:has(input[type="radio"][name*="Couleur du cadre"]), fieldset.product-form__controls:has(input[type="radio"][name*="Couleur de cadre"])')
		if (frameColorFieldset) {
			return frameColorFieldset
		}
		
		// Fallback: try by position (3rd select)
		const selects = this.querySelectorAll('select')
		if (selects.length >= 3) {
			return selects[2]
		}
		
		return null
	}

	/**
	 * Whether the PDP URL already contains an intentional variant/option selection.
	 * Featured products do not own the page URL, so their picker can still use its default.
	 * @returns {boolean}
	 */
	hasExplicitUrlSelection() {
		if (this.dataset.updateUrl === 'false' || this.classList.contains('featured-product-radios')) {
			return false
		}

		const params = new URLSearchParams(window.location.search)
		return Array.from(params.keys()).some((key) => {
			return key === 'variant' || key === 'option_values' || /^option\d*$/.test(key) || /^options\[.+\]$/.test(key)
		})
	}

	getOptionName(fieldset) {
		const input = fieldset.querySelector('select[name], input[name]')
		const match = input?.name?.match(/^options\[(.+)\]$/)
		return (match?.[1] || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
	}

	getOptionValuesInDisplayOrder(fieldset) {
		const select = fieldset.querySelector('select')
		if (select) {
			return Array.from(select.options).map((option) => option.value).filter(Boolean)
		}

		return Array.from(fieldset.querySelectorAll('input[type="radio"]'))
			.map((input) => input.value)
			.filter(Boolean)
	}

	/**
	 * Pick the Print variant for the lowest displayed size. Within that combination,
	 * prefer the lowest price (normally the unframed/None variant). If that exact
	 * entry-level variant is unavailable, fall back to the first available variant.
	 */
	getDefaultVariant() {
		const variantData = this.getVariantData()
		if (!variantData || !Array.isArray(variantData)) return

		const availableVariants = variantData.filter((variant) => variant.available)
		if (!availableVariants.length) return variantData[0]

		const fieldsets = Array.from(this.querySelectorAll('.product-form__controls'))
		const optionNames = fieldsets.map((fieldset) => this.getOptionName(fieldset))
		const printTypeIndex = optionNames.findIndex((name) => {
			return name === 'print type' || (name.includes('type') && name.includes('impression'))
		})
		const sizeIndex = optionNames.findIndex((name) => name === 'size' || name === 'taille')

		let candidates = variantData
		if (printTypeIndex >= 0) {
			const printCandidates = variantData.filter((variant) => {
				const printType = (variant.options[printTypeIndex] || '')
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
				return printType === 'print' || printType === 'imprimer'
			})

			if (printCandidates.length) candidates = printCandidates
		}

		if (sizeIndex >= 0) {
			const sizeOrder = this.getOptionValuesInDisplayOrder(fieldsets[sizeIndex])
			const lowestAvailableSize = sizeOrder.find((size) => {
				return candidates.some((variant) => variant.options[sizeIndex] === size)
			})

			if (lowestAvailableSize) {
				candidates = candidates.filter((variant) => variant.options[sizeIndex] === lowestAvailableSize)
			}
		}

		const preferredVariant = candidates.reduce((lowest, variant) => {
			return Number(variant.price) < Number(lowest.price) ? variant : lowest
		}, candidates[0])

		return preferredVariant.available ? preferredVariant : availableVariants[0]
	}

	applyVariantToControls(variant) {
		if (!variant?.options) return

		const fieldsets = this.querySelectorAll('.product-form__controls')
		fieldsets.forEach((fieldset, index) => {
			const optionValue = variant.options[index]
			if (optionValue == null) return
			const select = fieldset.querySelector('select')
			if (select) {
				select.value = optionValue
			} else {
				const radios = fieldset.querySelectorAll('input[type="radio"]')
				radios.forEach((radio) => {
					radio.checked = radio.value === optionValue
				})
			}
		})
	}

	connectedCallback() {
		// Respect intentional PDP deep links; otherwise select the entry-level Print variant.
		if (!this.hasExplicitUrlSelection()) {
			this.applyVariantToControls(this.getDefaultVariant())
		}
		// Update Frame Color visibility first (this may show/hide the fieldset)
		this.updateFrameColourVisibility()
		
		// Now update options to get the current state (including Frame Color radio buttons)
		this.updateOptions()
		
		// Update Hanging Hardware visibility on initial load
		this.updateHangingHardwareVisibility()
		this.updateMasterId()
		
		const selects = this.querySelectorAll('select')
		this.previousPrintType = selects.length >= 2 ? selects[1].value : null
		
		// Check initial Print Type state and toggle materials section visibility
		const initialPrintType = selects.length >= 2 ? selects[1].value : null
		if (initialPrintType && initialPrintType.trim() !== '') {
			this.toggleVariantMaterialsVisibility(true)
		} else {
			this.toggleVariantMaterialsVisibility(false)
		}
		
		if (!this.currentVariant) {
			this.toggleAddButton(true, '', false)
			const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
			const sku = document.getElementById(`Sku-${this.dataset.section}`)
			
			if (inventory) inventory.classList.add('visibility-hidden')
			if (sku) sku.classList.add('visibility-hidden')
		} else {
			if (!this.closest('floated-form') && this.currentVariant.featured_media) {
				this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`)
			}
			// Update price and other product info to match the reset first variant
			this.renderProductInfo()
			this.updateVariantInput()
			// Update mat details on initial load if variant is available
			this.updateMatDetails()
			// Sync URL to first variant after reset on reload
			this.updateURL()
		}
	}

	onVariantChange(event) {
		// Check if Print Type or Frame Color select/radio was changed BEFORE checking isUpdating
		// This allows us to capture the value even during rapid updates
		const selects = this.querySelectorAll('select')
		const printTypeSelect = selects.length >= 2 ? selects[1] : null
		
		// Get Frame Color input (could be select or radio)
		const frameColorInput = this.getFrameColorInput()
		const frameColorSelect = frameColorInput && frameColorInput.tagName === 'SELECT' ? frameColorInput : null
		const frameColorRadio = event && event.target && event.target.type === 'radio' && (event.target.name.includes('Frame Color') || event.target.name.includes('Frame Colour') || event.target.name.includes('Couleur du cadre') || event.target.name.includes('Couleur de cadre')) ? event.target : null
		
		const isPrintTypeChange = event && event.target === printTypeSelect
		const isFrameColorChange = event && (event.target === frameColorSelect || frameColorRadio !== null)
		
		const printTypeValueFromEvent = isPrintTypeChange && printTypeSelect ? printTypeSelect.value : null
		const frameColorValueFromEvent = isFrameColorChange ? (frameColorSelect ? frameColorSelect.value : (frameColorRadio ? frameColorRadio.value : null)) : null
		
		// Prevent recursive calls when programmatically changing select values
		if (this.isUpdating) {
			// Even if we're updating, if Print Type was directly changed, update materials immediately
			// This ensures materials update even during rapid variant changes
			if (isPrintTypeChange && printTypeValueFromEvent && printTypeValueFromEvent.trim() !== '') {
				this.updateMaterialsForPrintType(printTypeValueFromEvent)
			}
			// If Frame Color was directly changed, update mat details immediately
			if (isFrameColorChange && frameColorValueFromEvent && frameColorValueFromEvent.trim() !== '') {
				this.updateMatDetailsForFrameColor(frameColorValueFromEvent)
			}
			return
		}
		this.isUpdating = true
		
		try {
			// Store Print Type value BEFORE update functions (they might reset it)
			// This ensures we have the correct value even if updateVariantStatuses() resets the select
			const selects = this.querySelectorAll('select')
			const currentPrintType = printTypeValueFromEvent || (selects.length >= 2 ? selects[1].value : null)
			
			// Toggle materials section visibility based on Print Type selection
			if (currentPrintType && currentPrintType.trim() !== '') {
				this.toggleVariantMaterialsVisibility(true)
			} else {
				this.toggleVariantMaterialsVisibility(false)
			}
			
			// Update Frame Color visibility first (this may show/hide the fieldset)
			this.updateFrameColourVisibility()
			
			// Now update options to get the current state (including Frame Color radio buttons)
			this.updateOptions()
			
			// Update variant based on current options
			this.updateMasterId()
			
			// Update variant statuses (availability)
			this.updateVariantStatuses()
			
			// Ensure we have the final variant state after all operations
			this.updateOptions() // Re-collect options after status updates
			this.updateMasterId()
			
			// Update frame colour visibility again after variant is updated
			// This ensures mat details visibility is updated correctly when switching print types
			this.updateFrameColourVisibility()
			
			this.toggleAddButton(true, '', false)
			this.updatePickupAvailability()

			// Update materials whenever Print Type is selected, regardless of other variant selections
			// This ensures materials update immediately when Print Type is selected, even before Size is selected
			// Use the stored value from the event to ensure we have the correct value even if selects were reset
			const printTypeToUse = printTypeValueFromEvent || currentPrintType
			if (printTypeToUse && printTypeToUse.trim() !== '') {
				// Always update materials when Print Type has a value, not just when directly changed
				// This ensures materials update when Size changes (which triggers variant change) and Print Type is already selected
				this.updateMaterialsForPrintType(printTypeToUse)
			} else {
				this.toggleVariantMaterialsVisibility(false)
			}

			// Update Hanging Hardware visibility when print type changes
			// This ensures visibility is updated even if materials haven't been fetched yet
			this.updateHangingHardwareVisibility()

			// Update mat details whenever Frame Color is selected, regardless of other variant selections
			// This ensures mat details update immediately when Frame Color is selected, even before Size is selected
			const frameColorToUse = frameColorValueFromEvent || this.getFrameColorValue()
			if (isFrameColorChange && frameColorToUse && frameColorToUse.trim() !== '') {
				// Update frame colour visibility which will also update mat details visibility
				this.updateFrameColourVisibility()
				this.updateMatDetailsForFrameColor(frameColorToUse)
			} else if (isFrameColorChange) {
				// Frame Color was cleared, update visibility
				this.updateFrameColourVisibility()
			}

			if (!this.currentVariant) {
				this.toggleAddButton(true, '', false)
				const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
				const sku = document.getElementById(`Sku-${this.dataset.section}`)
				
				if (inventory) inventory.classList.add('visibility-hidden')
				if (sku) sku.classList.add('visibility-hidden')
			} else {
				if (!this.closest('floated-form') && this.currentVariant.featured_media) {
					this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`)
				}
				this.updateURL()
				this.updateVariantInput()
				// Enable button immediately if variant is available, before fetch completes
				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
				this.renderProductInfo()
				// Update mat details when variant changes
				this.updateMatDetails()
			}
			
			this.previousPrintType = currentPrintType
		} catch (error) {
			// Silently handle errors to prevent breaking the variant selection flow
		} finally {
			// Use setTimeout to allow any programmatic changes to complete before allowing next call
			setTimeout(() => {
				this.isUpdating = false
			}, 0)
		}
	}

	updateOptions() {
		// Collect values from visible selects and Frame Color radio buttons (exclude hidden options)
		const optionValues = []
		
		// Get all fieldsets in order (they should match the option order: Size, Print Type, Frame Color)
		const fieldsets = Array.from(this.querySelectorAll('.product-form__controls'))
		
		fieldsets.forEach((fieldset) => {
			// Skip if fieldset is hidden
			if (fieldset.hasAttribute('data-hidden') || fieldset.style.display === 'none') {
				optionValues.push(null)
				return
			}
			
			// Check for select first
			const select = fieldset.querySelector('select')
			if (select) {
				// For selects, check if it's the placeholder/empty option
				const value = select.value
				if (value === '' || value === null) {
					optionValues.push('')
				} else {
					optionValues.push(value)
				}
				return
			}
			
			// Check for radio buttons (Frame Color)
			const checkedRadio = fieldset.querySelector('input[type="radio"]:checked')
			if (checkedRadio) {
				optionValues.push(checkedRadio.value)
				return
			}
			
			// No selection made - this is important for Frame Color when nothing is selected
			optionValues.push('')
		})
		
		// Filter out null entries from hidden fields, but keep empty strings for unselected options
		this.options = optionValues.filter(value => value !== null)
	}

	updateFrameColourVisibility() {
		const selects = this.querySelectorAll('select')
		
		// Find Print Type select (2nd select)
		const printTypeSelect = selects.length >= 2 ? selects[1] : null
		// Find Size select (1st select) to determine if a Size has been chosen
		const sizeSelect = selects.length >= 1 ? selects[0] : null
		if (!printTypeSelect) return
		
		// Find Frame Color fieldset by searching for inputs with name containing "Frame Color", "Frame Colour", or French "Couleur du cadre"/"Couleur de cadre"
		let frameColorInput = this.querySelector('select[name*="Frame Color"], select[name*="Frame Colour"], select[name*="Couleur du cadre"], select[name*="Couleur de cadre"]')
		if (!frameColorInput) {
			// Try to find radio button
			frameColorInput = this.querySelector('input[type="radio"][name*="Frame Color"], input[type="radio"][name*="Frame Colour"], input[type="radio"][name*="Couleur du cadre"], input[type="radio"][name*="Couleur de cadre"]')
		}
		if (!frameColorInput) {
			// Fallback: try by position (3rd select)
			if (selects.length >= 3) {
				const frameColourSelect = selects[2]
				const frameColourFieldset = frameColourSelect.closest('.product-form__controls')
				if (frameColourFieldset) {
					const printTypeValue = printTypeSelect.value.toLowerCase()
					const shouldShowFrameColour = printTypeValue.includes('framed') || 
					                              printTypeValue.includes('encadré') || 
					                              printTypeValue.includes('encadrée')
					
					if (shouldShowFrameColour) {
						frameColourFieldset.style.display = ''
						frameColourFieldset.removeAttribute('data-hidden')
					} else {
						frameColourFieldset.style.display = 'none'
						frameColourFieldset.setAttribute('data-hidden', 'true')
						if (frameColourSelect.value !== '') {
							frameColourSelect.value = ''
							this.updateOptions()
							this.updateMasterId()
						}
					}
				}
			}
			return
		}
		
		const frameColourFieldset = frameColorInput.closest('.product-form__controls')
		if (!frameColourFieldset) return
		
		const printTypeValue = printTypeSelect.value.toLowerCase()
		const shouldShowFrameColour = printTypeValue.includes('framed') || 
		                              printTypeValue.includes('encadré') || 
		                              printTypeValue.includes('encadrée')
		
		if (shouldShowFrameColour) {
			// Show Frame Colour option
			frameColourFieldset.style.display = ''
			frameColourFieldset.removeAttribute('data-hidden')
		} else {
			// Hide Frame Colour option
			frameColourFieldset.style.display = 'none'
			frameColourFieldset.setAttribute('data-hidden', 'true')
			
			// Reset Frame Colour - handle both select and radio buttons
			if (frameColorInput.tagName === 'SELECT') {
				// Reset select to empty
				if (frameColorInput.value !== '') {
					frameColorInput.value = ''
					this.updateOptions()
					this.updateMasterId()
				}
			} else if (frameColorInput.type === 'radio') {
				// Uncheck all Frame Color radio buttons
				const frameColorRadios = frameColourFieldset.querySelectorAll('input[type="radio"][name*="Frame Color"], input[type="radio"][name*="Frame Colour"], input[type="radio"][name*="Couleur du cadre"], input[type="radio"][name*="Couleur de cadre"]')
				frameColorRadios.forEach(radio => {
					if (radio.checked) {
						radio.checked = false
					}
				})
				this.updateOptions()
				this.updateMasterId()
			}
		}
		
		// Mat Details visibility logic
		const matDetailsSection = document.getElementById(`MatDetails-${this.dataset.section}`)
		
		if (!matDetailsSection) return
		
		// Check for "with mat" in the print type value (case insensitive)
		const hasMatInPrintType = printTypeValue.includes('with mat') || 
		                          printTypeValue.includes('avec passe-partout') || 
		                          printTypeValue.includes('avec mat')
		
		// First check if current variant has_mat metafield is false (if variant exists)
		// But only hide for "Framed Print with Mat" - for Framed Print and Framed Canvas, we still want to show Overall Dimensions
		if (this.currentVariant && hasMatInPrintType) {
			const hasMatMetafield = this.currentVariant?.metafields?.custom?.has_mat
			// Check for false (boolean) or 'false' (string) - explicitly check for false values
			// Also handle error object case (backwards compatibility)
			const isHasMatFalse = hasMatMetafield === false || 
			                      hasMatMetafield === 'false' || 
			                      (hasMatMetafield != null && typeof hasMatMetafield === 'object' && hasMatMetafield.error) ||
			                      (hasMatMetafield != null && String(hasMatMetafield).toLowerCase() === 'false')
			
			// If has_mat is false, hide mat details immediately (only for "Framed Print with Mat")
			if (isHasMatFalse) {
				matDetailsSection.style.display = 'none'
				matDetailsSection.setAttribute('data-hidden', 'true')
				return
			}
		}
		// Check for "Framed Print" or "Framed Canvas" (without mat) - English and French
		const isFramedPrint = (printTypeValue.includes('framed print') || printTypeValue.includes('impression encadrée')) && !hasMatInPrintType
		const isFramedCanvas = printTypeValue.includes('framed canvas') || 
		                       printTypeValue.includes('toile encadrée')

		// Check if Size is selected (non-empty value; placeholder has empty value)
		const isSizeSelected = !!(sizeSelect && sizeSelect.value && sizeSelect.value.trim() !== '')

		// Check if Frame Color fieldset is visible
		const isFrameColorFieldsetVisible = !frameColourFieldset.hasAttribute('data-hidden') && frameColourFieldset.style.display !== 'none'
		// Check if Frame Color is selected (not empty and not placeholder) - handle both select and radio, English and French
		const frameColorValue = this.getFrameColorValue()
		const isFrameColorSelected = frameColorValue && frameColorValue.trim() !== '' && frameColorValue !== 'Select Frame Color' && frameColorValue !== 'Sélectionner la couleur du cadre' && frameColorValue !== 'Sélectionner couleur du cadre'
		
		// Show mat details if:
		// 1. "Framed Print with Mat" (hasMatInPrintType) AND Size is selected AND Frame Color fieldset is visible AND Frame Color is selected, OR
		// 2. "Framed Print" (without mat) AND Frame Color fieldset is visible AND Frame Color is selected, OR
		// 3. "Framed Canvas" AND Frame Color fieldset is visible AND Frame Color is selected
		// Note: The extra Size requirement only applies to the \"with mat\" case per business rules.
		const shouldShowMatDetails = (hasMatInPrintType && isSizeSelected && isFrameColorFieldsetVisible && isFrameColorSelected) ||
		                              (isFramedPrint && isFrameColorFieldsetVisible && isFrameColorSelected) ||
		                              (isFramedCanvas && isFrameColorFieldsetVisible && isFrameColorSelected)
		
		if (shouldShowMatDetails) {
			matDetailsSection.style.display = 'block'
			matDetailsSection.removeAttribute('data-hidden')
			// Update mat details when showing (only if variant exists)
			if (this.currentVariant) {
				this.updateMatDetails()
			}
		} else {
			matDetailsSection.style.display = 'none'
			matDetailsSection.setAttribute('data-hidden', 'true')
		}
	}
	
	updateMatDetails() {
		if (!this.currentVariant) return
		
		const matDetailsSection = document.getElementById(`MatDetails-${this.dataset.section}`)
		if (!matDetailsSection) return
		
		// Determine product type from variant options (option2 is Print Type)
		const printTypeValue = this.currentVariant.options[1] ? this.currentVariant.options[1].toLowerCase() : ''
		const hasMatInPrintType = printTypeValue.includes('with mat') || 
		                          printTypeValue.includes('avec passe-partout') || 
		                          printTypeValue.includes('avec mat')
		const isFramedPrint = (printTypeValue.includes('framed print') || printTypeValue.includes('impression encadrée')) && !hasMatInPrintType
		const isFramedCanvas = printTypeValue.includes('framed canvas') || 
		                       printTypeValue.includes('toile encadrée')
		
		// Check if has_mat metafield is false - if so, hide mat details and return (handle both boolean and string)
		// But only for "Framed Print with Mat" - for Framed Print and Framed Canvas, we still want to show Overall Dimensions
		const hasMatMetafield = this.currentVariant.metafields?.custom?.has_mat
		// Check for false (boolean) or 'false' (string) - explicitly check for false values
		// Also handle error object case (backwards compatibility)
		const isHasMatFalse = hasMatMetafield === false || 
		                      hasMatMetafield === 'false' || 
		                      (hasMatMetafield != null && typeof hasMatMetafield === 'object' && hasMatMetafield.error) ||
		                      (hasMatMetafield != null && String(hasMatMetafield).toLowerCase() === 'false')
		
		// Only hide if has_mat is false AND it's "Framed Print with Mat" (not Framed Print or Framed Canvas)
		if (isHasMatFalse && hasMatInPrintType) {
			matDetailsSection.style.display = 'none'
			matDetailsSection.setAttribute('data-hidden', 'true')
			return
		}
		
		// Get mat metafields from current variant
		// Metafields structure: variant.metafields.custom.mat_color, etc.
		const matColor = this.currentVariant.metafields?.custom?.mat_color
		const matStyle = this.currentVariant.metafields?.custom?.mat_style
		const matWidth = this.currentVariant.metafields?.custom?.mat_width
		const overallDimentions = this.currentVariant.metafields?.custom?.overall_dimentions
		
		// Update mat detail values and visibility
		const matColorElement = matDetailsSection.querySelector('[data-mat-color]')
		const matStyleElement = matDetailsSection.querySelector('[data-mat-style]')
		const matWidthElement = matDetailsSection.querySelector('[data-mat-width]')
		const overallDimentionsElement = matDetailsSection.querySelector('[data-overall-dimentions]')
		
		// For Framed Print and Framed Canvas, hide mat-specific fields (only show Overall Dimensions)
		const shouldHideMatFields = isFramedPrint || isFramedCanvas
		
		// Hide/show mat-details-title based on product type
		const matDetailsTitle = matDetailsSection.querySelector('.mat-details-title')
		if (matDetailsTitle) {
			if (shouldHideMatFields) {
				matDetailsTitle.style.display = 'none'
			} else {
				matDetailsTitle.style.display = ''
			}
		}
		
		// Mat Color
		if (matColorElement) {
			const matColorItem = matColorElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matColorElement.textContent = ''
				if (matColorItem) matColorItem.style.display = 'none'
			} else if (matColor && matColor.trim() !== '') {
				matColorElement.textContent = matColor
				if (matColorItem) matColorItem.style.display = ''
			} else {
				matColorElement.textContent = ''
				if (matColorItem) matColorItem.style.display = 'none'
			}
		}
		
		// Mat Style
		if (matStyleElement) {
			const matStyleItem = matStyleElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matStyleElement.textContent = ''
				if (matStyleItem) matStyleItem.style.display = 'none'
			} else if (matStyle && matStyle.trim() !== '') {
				matStyleElement.textContent = matStyle
				if (matStyleItem) matStyleItem.style.display = ''
			} else {
				matStyleElement.textContent = ''
				if (matStyleItem) matStyleItem.style.display = 'none'
			}
		}
		
		// Mat Width
		if (matWidthElement) {
			const matWidthItem = matWidthElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matWidthElement.textContent = ''
				if (matWidthItem) matWidthItem.style.display = 'none'
			} else if (matWidth && matWidth.trim() !== '') {
				matWidthElement.textContent = matWidth
				if (matWidthItem) matWidthItem.style.display = ''
			} else {
				matWidthElement.textContent = ''
				if (matWidthItem) matWidthItem.style.display = 'none'
			}
		}
		
		// Overall Dimensions
		if (overallDimentionsElement) {
			const overallDimentionsItem = overallDimentionsElement.closest('.mat-detail-item')
			if (overallDimentions && overallDimentions.trim() !== '') {
				overallDimentionsElement.textContent = overallDimentions
				if (overallDimentionsItem) overallDimentionsItem.style.display = ''
			} else {
				overallDimentionsElement.textContent = ''
				if (overallDimentionsItem) overallDimentionsItem.style.display = 'none'
			}
		}
		
		// Check if any mat-detail-item is visible
		const allMatDetailItems = matDetailsSection.querySelectorAll('.mat-detail-item')
		const hasVisibleItems = Array.from(allMatDetailItems).some(item => {
			return item.style.display !== 'none' && window.getComputedStyle(item).display !== 'none'
		})
		
		// Hide the entire mat-details section if no items are visible
		if (!hasVisibleItems) {
			matDetailsSection.style.display = 'none'
			matDetailsSection.setAttribute('data-hidden', 'true')
		}
	}

	updateMatDetailsForFrameColor(frameColor) {
		if (!frameColor || frameColor.trim() === '') return

		const matDetailsSection = document.getElementById(`MatDetails-${this.dataset.section}`)
		if (!matDetailsSection) return

		const variantData = this.getVariantData()
		if (!variantData || !Array.isArray(variantData)) return
		
		// Get all currently selected options to find the best matching variant
		const selects = this.querySelectorAll('select')
		const visibleIndices = []
		
		selects.forEach((select, index) => {
			const fieldset = select.closest('.product-form__controls')
			if (!fieldset || !fieldset.hasAttribute('data-hidden')) {
				visibleIndices.push(index)
			}
		})
		
		// Find variant that matches all currently selected options
		// Priority: available variant matching all options > any variant matching all options > variant matching Frame Color + Print Type
		let variant = null
		
		// First, try to find a variant matching all selected options (if any are selected)
		if (this.options && this.options.length > 0 && this.options[0] !== '' && this.options[0] !== null) {
			variant = variantData.find((v) => {
				// Match all visible selected options
				return visibleIndices.every((visibleIndex, arrayIndex) => {
					return this.options[arrayIndex] === v.options[visibleIndex]
				}) && v.available
			}) || variantData.find((v) => {
				// Match all visible selected options (even if not available)
				return visibleIndices.every((visibleIndex, arrayIndex) => {
					return this.options[arrayIndex] === v.options[visibleIndex]
				})
			})
		}
		
		// Fallback: find variant matching Frame Color + Print Type if no other options are selected
		if (!variant && selects.length >= 3) {
			const printTypeValue = selects[1] ? selects[1].value : null
			if (printTypeValue && printTypeValue.trim() !== '') {
				variant = variantData.find((v) => 
					v.options[1] === printTypeValue && 
					v.options[2] === frameColor && 
					v.available
				) || variantData.find((v) => 
					v.options[1] === printTypeValue && 
					v.options[2] === frameColor
				)
			}
		}

		if (!variant) return

		// Determine product type from variant options (option2 is Print Type)
		const printTypeValue = variant.options[1] ? variant.options[1].toLowerCase() : ''
		const hasMatInPrintType = printTypeValue.includes('with mat') || 
		                          printTypeValue.includes('avec passe-partout') || 
		                          printTypeValue.includes('avec mat')
		const isFramedPrint = (printTypeValue.includes('framed print') || printTypeValue.includes('impression encadrée')) && !hasMatInPrintType
		const isFramedCanvas = printTypeValue.includes('framed canvas') || 
		                       printTypeValue.includes('toile encadrée')

		// Check if has_mat metafield is false - if so, hide mat details and return (handle both boolean and string)
		// But only for "Framed Print with Mat" - for Framed Print and Framed Canvas, we still want to show Overall Dimensions
		const hasMatMetafield = variant.metafields?.custom?.has_mat
		// Check for false (boolean) or 'false' (string) - explicitly check for false values
		// Also handle error object case (backwards compatibility)
		const isHasMatFalse = hasMatMetafield === false || 
		                      hasMatMetafield === 'false' || 
		                      (hasMatMetafield != null && typeof hasMatMetafield === 'object' && hasMatMetafield.error) ||
		                      (hasMatMetafield != null && String(hasMatMetafield).toLowerCase() === 'false')
		
		// Only hide if has_mat is false AND it's "Framed Print with Mat" (not Framed Print or Framed Canvas)
		if (isHasMatFalse && hasMatInPrintType) {
			matDetailsSection.style.display = 'none'
			matDetailsSection.setAttribute('data-hidden', 'true')
			return
		}

		// Get mat metafields from the found variant
		const matColor = variant.metafields?.custom?.mat_color
		const matStyle = variant.metafields?.custom?.mat_style
		const matWidth = variant.metafields?.custom?.mat_width
		const overallDimentions = variant.metafields?.custom?.overall_dimentions
		
		// Update mat detail values and visibility
		const matColorElement = matDetailsSection.querySelector('[data-mat-color]')
		const matStyleElement = matDetailsSection.querySelector('[data-mat-style]')
		const matWidthElement = matDetailsSection.querySelector('[data-mat-width]')
		const overallDimentionsElement = matDetailsSection.querySelector('[data-overall-dimentions]')
		
		// For Framed Print and Framed Canvas, hide mat-specific fields (only show Overall Dimensions)
		const shouldHideMatFields = isFramedPrint || isFramedCanvas
		
		// Hide/show mat-details-title based on product type
		const matDetailsTitle = matDetailsSection.querySelector('.mat-details-title')
		if (matDetailsTitle) {
			if (shouldHideMatFields) {
				matDetailsTitle.style.display = 'none'
			} else {
				matDetailsTitle.style.display = ''
			}
		}
		
		// Mat Color
		if (matColorElement) {
			const matColorItem = matColorElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matColorElement.textContent = ''
				if (matColorItem) matColorItem.style.display = 'none'
			} else if (matColor && matColor.trim() !== '') {
				matColorElement.textContent = matColor
				if (matColorItem) matColorItem.style.display = ''
			} else {
				matColorElement.textContent = ''
				if (matColorItem) matColorItem.style.display = 'none'
			}
		}
		
		// Mat Style
		if (matStyleElement) {
			const matStyleItem = matStyleElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matStyleElement.textContent = ''
				if (matStyleItem) matStyleItem.style.display = 'none'
			} else if (matStyle && matStyle.trim() !== '') {
				matStyleElement.textContent = matStyle
				if (matStyleItem) matStyleItem.style.display = ''
			} else {
				matStyleElement.textContent = ''
				if (matStyleItem) matStyleItem.style.display = 'none'
			}
		}
		
		// Mat Width
		if (matWidthElement) {
			const matWidthItem = matWidthElement.closest('.mat-detail-item')
			if (shouldHideMatFields) {
				matWidthElement.textContent = ''
				if (matWidthItem) matWidthItem.style.display = 'none'
			} else if (matWidth && matWidth.trim() !== '') {
				matWidthElement.textContent = matWidth
				if (matWidthItem) matWidthItem.style.display = ''
			} else {
				matWidthElement.textContent = ''
				if (matWidthItem) matWidthItem.style.display = 'none'
			}
		}
		
		// Overall Dimensions
		if (overallDimentionsElement) {
			const overallDimentionsItem = overallDimentionsElement.closest('.mat-detail-item')
			if (overallDimentions && overallDimentions.trim() !== '') {
				overallDimentionsElement.textContent = overallDimentions
				if (overallDimentionsItem) overallDimentionsItem.style.display = ''
			} else {
				overallDimentionsElement.textContent = ''
				if (overallDimentionsItem) overallDimentionsItem.style.display = 'none'
			}
		}
		
		// Check if any mat-detail-item is visible
		const allMatDetailItems = matDetailsSection.querySelectorAll('.mat-detail-item')
		const hasVisibleItems = Array.from(allMatDetailItems).some(item => {
			return item.style.display !== 'none' && window.getComputedStyle(item).display !== 'none'
		})
		
		// Hide the entire mat-details section if no items are visible
		if (!hasVisibleItems) {
			matDetailsSection.style.display = 'none'
			matDetailsSection.setAttribute('data-hidden', 'true')
		}
	}

	updateMasterId() {
		// Check if any option is empty (placeholder selected or no radio button checked)
		if (this.options.includes('') || this.options.includes(null) || this.options.includes(undefined)) {
			this.currentVariant = null
			return
		}

		if (this.variantData || this.querySelector('[type="application/json"]')) {
			// Get all fieldsets in order to determine visible option indices
			// This accounts for both selects and radio buttons
			const fieldsets = Array.from(this.querySelectorAll('.product-form__controls'))
			const visibleIndices = []
			
			fieldsets.forEach((fieldset, index) => {
				// Only include visible fieldsets (not hidden)
				if (!fieldset.hasAttribute('data-hidden') && fieldset.style.display !== 'none') {
					visibleIndices.push(index)
				}
			})
			
			// Now match options with variant data
			// this.options array should match the order of visible fieldsets
			this.currentVariant = this.getVariantData().find((variant) => {
				// Match all visible selected options
				// visibleIndices[i] is the option index (0, 1, 2 for option1, option2, option3)
				// this.options[i] is the selected value for that visible option
				return visibleIndices.every((optionIndex, arrayIndex) => {
					return this.options[arrayIndex] === variant.options[optionIndex]
				})
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(mediaId) {
		if (!this.currentVariant) return

		const currentSection = document.querySelector(`[data-section="main-${this.dataset.section}"]`)

		if (currentSection) {
			// Update main gallery
			this.mediaList = currentSection.querySelector('.product__media-list')
			if (this.mediaList) {
				const activeMedia = this.mediaList.querySelector(`[data-media-id="${mediaId}"]`)
				this.mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
					element.classList.remove('active')
				})
				if (activeMedia) activeMedia.classList.add('active')

				const mediaElements = Array.from(this.mediaList.querySelectorAll('.product__media-item'))
				const index = mediaElements.indexOf(activeMedia)

				if (index >= 0) {
					// Only show the active item, hide all others - Desktop only (above 750px)
					const totalItems = mediaElements.length
					const isDesktop = window.innerWidth >= 750
					
					if (isDesktop) {
						// Mark that visibility is being managed
						this.mediaList.classList.add('product__media-list--visibility-managed')
						
						// Remove visible class from all items
						mediaElements.forEach((element) => {
							element.classList.remove('product__media-item--visible')
						})
						
						// Only add visible class to the active item
						if (activeMedia) {
							activeMedia.classList.add('product__media-item--visible')
						}
					} else {
						// On mobile, show all items
						this.mediaList.classList.remove('product__media-list--visibility-managed')
						mediaElements.forEach((element) => {
							element.classList.add('product__media-item--visible')
						})
					}

					if (this.closest('.product__outer')?.querySelector('.product__media-list')) {
						this.closest('.product__outer').querySelector('.product__media-list').dataset.currentIndex = index
					}

					// Update swiper for main gallery
					const swiperContainer = this.mediaList.closest('.swiper')
					if (swiperContainer && swiperContainer.swiper) {
						swiperContainer.swiper.slideTo(index)
					}
				}
			}

			// Update thumbnail gallery
			const sublist = currentSection.querySelector('.product__media-sublist')
			if (sublist) {
				const activeThumb = sublist.querySelector(`[data-media-sub-id="${mediaId}"]`)
				sublist.querySelectorAll('[data-media-sub-id]').forEach((element) => {
					element.classList.remove('active')
				})
				if (activeThumb) {
					activeThumb.classList.add('active')
					const thumbElements = Array.from(sublist.querySelectorAll('.product__media-subitem'))
					const thumbIndex = thumbElements.indexOf(activeThumb)
					
					if (thumbIndex >= 0 && sublist.swiper) {
						sublist.swiper.slideTo(thumbIndex)
					}
				}
			}
		}

		// Handle swiper wrappers for mobile/alternate views
		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')
		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(`[data-media-id="${mediaId}"]`)
				
				if (newMedia) {
					if (elem.querySelector('.js-media-list') && elem.querySelector('.js-media-list').swiper) {
						const swiper = elem.querySelector('.js-media-list').swiper
						const slideIndex = swiper.slides.indexOf(newMedia)
						if (slideIndex >= 0) {
							swiper.slideTo(slideIndex)
						}
					} else if (
						elem.querySelector('.js-media-list-mobile') &&
						elem.querySelector('.js-media-list-mobile').swiper
					) {
						const swiper = elem.querySelector('.js-media-list-mobile').swiper
						const slideIndex = swiper.slides.indexOf(newMedia)
						if (slideIndex >= 0) {
							swiper.slideTo(slideIndex)
						}
					}
				}
			}
		})
	}


	updateURL() {
		if (!this.classList.contains('featured-product-radios')) {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		// Ensure variantData is initialized before using it
		const variantData = this.getVariantData()
		if (!variantData || !Array.isArray(variantData)) return

		// Get the first option value (Size) - check both radio buttons and select dropdowns
		const firstOptionWrapper = this.querySelector('.product-form__controls')
		if (!firstOptionWrapper) return
		
		const firstChecked = firstOptionWrapper.querySelector(':checked')
		const firstSelect = firstOptionWrapper.querySelector('select')
		const firstOptionValue = firstChecked ? firstChecked.value : (firstSelect ? firstSelect.value : null)
		
		// If no first option is selected, enable all options in subsequent selects
		if (!firstOptionValue || firstOptionValue === '') {
			const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
			inputWrappers.forEach((option, index) => {
				if (index === 0) return
				const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
				// Get all unique values for this option from variant data to enable all options
				const allOptionValues = [...new Set(variantData.map(v => v[`option${index + 1}`]).filter(v => v))]
				this.setInputAvailability(optionInputs, allOptionValues)
			})
			return
		}

		const selectedOptionOneVariants = variantData.filter(
			(variant) => firstOptionValue === variant.option1,
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			
			// Get previous option value - check both radio buttons and select dropdowns
			const previousOptionWrapper = inputWrappers[index - 1]
			const previousChecked = previousOptionWrapper.querySelector(':checked')
			const previousSelect = previousOptionWrapper.querySelector('select')
			const previousOptionSelected = previousChecked ? previousChecked.value : (previousSelect ? previousSelect.value : null)
			
			if (!previousOptionSelected || previousOptionSelected === '') {
				// If previous option is not selected, enable all options for this option index
				const allOptionValues = [...new Set(variantData.map(v => v[`option${index + 1}`]).filter(v => v))]
				this.setInputAvailability(optionInputs, allOptionValues)
				return
			}

			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
			
			// Reset select dropdown to placeholder if current selection is now disabled
			const select = option.querySelector('select')
			if (select && select.value && !availableOptionInputsValue.includes(select.value)) {
				select.value = ''
			}
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			// Skip placeholder options (empty value)
			if (input.tagName === 'OPTION' && input.getAttribute('value') === '') {
				return
			}

			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
					input.removeAttribute('disabled')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				}
			} else {
				if (input.tagName === 'OPTION') {
					// Show just the value without "- Unavailable" text
					input.innerText = input.getAttribute('value')
					// Disable the option so it can't be selected
					input.setAttribute('disabled', 'disabled')
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		// Add cache-busting timestamp to prevent caching issues when switching between variants
		const cacheBuster = `&_=${Date.now()}`
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}${cacheBuster}`,
			{
				cache: 'no-store'
			}
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant?.id !== requestedVariantId) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(`price-${this.dataset.section}`)
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
					}`,
				)
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
					}`,
				)
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
					}`,
				)
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)
				const colorNameSources = html.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
					}"]`,
				)
				const colorNameDestinations = document.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection && !this.closest('quick-add-modal')
							? this.dataset.originalSection
							: this.dataset.section
					}"]`,
				)
				if (colorNameSources?.length === colorNameDestinations?.length) {
					colorNameDestinations.forEach((colorNameDestination, index) => {
						colorNameDestination.innerHTML = colorNameSources[index].innerHTML
					})
				}

				if (source && destination) destination.innerHTML = source.innerHTML
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML
					skuDestination.classList.toggle(
						'visibility-hidden',
						skuSource.classList.contains('visibility-hidden'),
					)
				}

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('visibility-hidden')

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						'visibility-hidden',
						inventorySource.innerText === '',
					)

				// Update materials content for variant-specific materials
				this.updateMaterialsContent(html, sectionId)

				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
			})
			.catch((error) => {
				// If fetch fails, ensure button is still enabled if variant is available
				if (this.currentVariant?.id === requestedVariantId) {
					this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
				}
			})
	}

	toggleVariantMaterialsVisibility(show) {
		const variantMaterialsSection = document.getElementById(`VariantMaterials-${this.dataset.section}`)
		if (variantMaterialsSection) {
			if (show) {
				variantMaterialsSection.removeAttribute('data-hidden')
			} else {
				variantMaterialsSection.setAttribute('data-hidden', 'true')
			}
		}
	}

	updateMaterialsContent(html, sectionId) {
		const materialsDestination = document.getElementById(`MaterialsContent-${this.dataset.section}`)
		if (!materialsDestination) {
			return
		}

		const materialsSource = html.getElementById(`MaterialsContent-${sectionId}`)
		if (!materialsSource) {
			return
		}

		const variantMaterialsDestination = materialsDestination.querySelector(`#VariantMaterials-${this.dataset.section}`)
		const variantMaterialsSource = materialsSource.querySelector(`#VariantMaterials-${sectionId}`)

		if (variantMaterialsDestination) {
			const sourceContent = variantMaterialsSource ? variantMaterialsSource.innerHTML : ''
			variantMaterialsDestination.innerHTML = sourceContent
		}

		// Update Hanging Hardware section
		const hangingHardwareDestination = materialsDestination.querySelector(`[data-hanging-hardware-section]`)
		const hangingHardwareSource = materialsSource.querySelector(`[data-hanging-hardware-section]`)

		if (hangingHardwareSource) {
			// If source has hanging hardware, update or create it
			if (hangingHardwareDestination) {
				hangingHardwareDestination.outerHTML = hangingHardwareSource.outerHTML
			} else {
				// Insert after packaging section if it doesn't exist
				const packagingSection = materialsDestination.querySelector('.materials-section--static:not([data-hanging-hardware-section])')
				if (packagingSection) {
					// Clone the node and insert it after packaging section
					const clonedNode = hangingHardwareSource.cloneNode(true)
					if (packagingSection.nextSibling) {
						packagingSection.parentNode.insertBefore(clonedNode, packagingSection.nextSibling)
					} else {
						packagingSection.parentNode.appendChild(clonedNode)
					}
				}
			}
		} else if (hangingHardwareDestination) {
			// If source doesn't have hanging hardware but destination does, remove it
			hangingHardwareDestination.remove()
		}

		// Update hanging hardware visibility based on current print type
		// Use setTimeout to ensure DOM is updated before checking visibility
		setTimeout(() => {
			this.updateHangingHardwareVisibility()
		}, 0)
	}

	updateHangingHardwareVisibility() {
		const materialsDestination = document.getElementById(`MaterialsContent-${this.dataset.section}`)
		if (!materialsDestination) {
			return
		}

		const hangingHardwareSection = materialsDestination.querySelector(`[data-hanging-hardware-section]`)
		if (!hangingHardwareSection) {
			return
		}

		// Get current print type value
		const selects = this.querySelectorAll('select')
		let printType = null
		
		// Try to find print type select (usually the 2nd select, index 1)
		if (selects.length >= 2) {
			printType = selects[1].value
		}

		// Check if print type is "Print" or "Imprimer"
		const isPrintType = printType && (
			printType.toLowerCase() === 'print' || 
			printType === 'Print' || 
			printType === 'Imprimer' || 
			printType.toLowerCase() === 'imprimer'
		)

		// Hide if print type is "Print", show otherwise
		if (isPrintType) {
			hangingHardwareSection.style.display = 'none'
		} else {
			hangingHardwareSection.style.display = ''
		}
	}

	updateMaterialsForPrintType(printType) {
		if (!printType || printType.trim() === '') {
			this.toggleVariantMaterialsVisibility(false)
			return
		}

		const variantData = this.getVariantData()
		
		// Get all currently selected options to find the best matching variant
		const selects = this.querySelectorAll('select')
		const visibleIndices = []
		
		selects.forEach((select, index) => {
			const fieldset = select.closest('.product-form__controls')
			if (!fieldset || !fieldset.hasAttribute('data-hidden')) {
				visibleIndices.push(index)
			}
		})
		
		// Find variant that matches all currently selected options
		// Priority: available variant matching all options > any variant matching all options > variant matching just Print Type
		let variant = null
		
		// First, try to find a variant matching all selected options (if any are selected)
		if (this.options && this.options.length > 0 && this.options[0] !== '' && this.options[0] !== null) {
			variant = variantData.find((v) => {
				// Match all visible selected options
				return visibleIndices.every((visibleIndex, arrayIndex) => {
					return this.options[arrayIndex] === v.options[visibleIndex]
				}) && v.available
			}) || variantData.find((v) => {
				// Match all visible selected options (even if not available)
				return visibleIndices.every((visibleIndex, arrayIndex) => {
					return this.options[arrayIndex] === v.options[visibleIndex]
				})
			})
		}
		
		// Fallback: find variant matching just Print Type if no other options are selected
		if (!variant) {
			variant = variantData.find((v) => v.options[1] === printType && v.available) ||
				variantData.find((v) => v.options[1] === printType)
		}

		if (!variant) {
			this.toggleVariantMaterialsVisibility(false)
			return
		}

		const sectionId = this.dataset.originalSection || this.dataset.section
		const cacheBuster = `&_=${Date.now()}`

		fetch(
			`${this.dataset.url}?variant=${variant.id}&section_id=${sectionId}${cacheBuster}`,
			{ cache: 'no-store' }
		)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')
				this.updateMaterialsContent(html, sectionId)
			})
			.catch((error) => {
				this.toggleVariantMaterialsVisibility(false)
			})
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	getVariantData() {
		this.variantData =
			this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
			} else {
				input.classList.add('disabled')
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
			return checkedRadio ? checkedRadio.value : ''
		})
	}

	updateVariantStatuses() {
		const firstChecked = this.querySelector(':checked')
		if (!firstChecked) return // No option selected yet

		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => firstChecked.value === variant.option1,
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			const previousChecked = inputWrappers[index - 1].querySelector(':checked')
			if (!previousChecked) return // No previous option selected

			const previousOptionSelected = previousChecked.value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
			
			// Uncheck radio button if current selection is now disabled
			const checkedRadio = option.querySelector('input[type="radio"]:checked')
			if (checkedRadio && !availableOptionInputsValue.includes(checkedRadio.value)) {
				checkedRadio.checked = false
			}
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()
		// Initialize loading guards to prevent multiple fetches
		this.isLoading = false
		this.hasLoaded = false
		this.resizeObserver = null
	}

	connectedCallback() {
		// Guard against multiple fetches
		if (this.isLoading || this.hasLoaded) {
			return
		}

		// Set loading flag
		this.isLoading = true

		// Load recommendations immediately instead of waiting for intersection
		fetch(this.dataset.url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div')
				html.innerHTML = text
				const recommendations = html.querySelector('product-recommendations')
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML
				}

				/* Color swatches */
				const generateSrcset = (image, widths = []) => {
					const imageUrl = new URL(image['src'])
					return widths
						.filter((width) => width <= image['width'])
						.map((width) => {
							imageUrl.searchParams.set('width', width.toString())
							return `${imageUrl.href} ${width}w`
						})
						.join(', ')
				}

				const createImageElement = (image, classes, sizes, productTitle) => {
					const previewImage = image['preview_image']
					const newImage = new Image(previewImage['width'], previewImage['height'])
					newImage.className = classes
					newImage.alt = image['alt'] || productTitle
					newImage.sizes = sizes
					newImage.src = previewImage['src']
					newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066])
					newImage.loading = 'lazy'
					return newImage
				}

				const checkSwatches = () => {
					document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
						wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
							input.addEventListener('click', (event) => {
								const primaryImage = wrapper.querySelector('.media--first')
								const secondaryImage = wrapper.querySelector('.media--second')
								const handleProduct = wrapper.dataset.product

								if (event.currentTarget.checked && primaryImage) {
									wrapper
										.querySelector('.js-color-swatches-link')
										.setAttribute('href', event.currentTarget.dataset.variantLink)
									if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
										wrapper
											.querySelector('.card__add-to-cart button[name="add"]')
											.setAttribute('aria-disabled', false)
										if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
											wrapper
												.querySelector('.card__add-to-cart button[name="add"] > span')
												.classList.remove('hidden')
											wrapper
												.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
												.classList.add('hidden')
										}
										wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
											event.currentTarget.dataset.variantId
									}
									const currentColor = event.currentTarget.value

									jQuery.getJSON(
										window.Shopify.routes.root + `products/${handleProduct}.js`,
										function (product) {
											const variant = product.variants.filter(
												(item) =>
													item.featured_media != null && item.options.includes(currentColor),
											)[0]

											if (variant) {
												const newPrimaryImage = createImageElement(
													variant['featured_media'],
													primaryImage.className,
													primaryImage.sizes,
													product.title,
												)

												if (newPrimaryImage.src !== primaryImage.src) {
													let flag = false
													if (secondaryImage) {
														const secondaryImagePathname = new URL(secondaryImage.src).pathname
														const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname

														if (secondaryImagePathname == newPrimaryImagePathname) {
															primaryImage.remove()
															secondaryImage.classList.remove('media--second')
															secondaryImage.classList.add('media--first')
															flag = true
														}
													}
													if (flag == false) {
														primaryImage.animate(
															{ opacity: [1, 0] },
															{
																duration: 200,
																easing: 'ease-in',
																fill: 'forwards',
															},
														).finished
														setTimeout(function () {
															primaryImage.replaceWith(newPrimaryImage)
															newPrimaryImage.animate(
																{ opacity: [0, 1] },
																{ duration: 200, easing: 'ease-in' },
															)
															if (secondaryImage) {
																secondaryImage.remove()
															}
														}, 200)
													}
												}
											}
										},
									)
								}
							})
						})
					})
				}

				checkSwatches()

				const calcTop = (section) => {
					// Check for standard product card structure
					let imageWrapper = section.querySelectorAll('.card__inner')
					
					// If not found, check for complementary product card structure
					if (imageWrapper.length === 0) {
						imageWrapper = section.querySelectorAll('.complementary-product-card__inner')
					}
					
					let top = 50 // Default fallback value
					
					if (imageWrapper.length > 0 && imageWrapper[0]) {
						top = imageWrapper[0].offsetHeight / 2
					}

					return top
				}

				const initSlider = (section) => {
					// Only query swipers within this section, not the entire document
					section.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
						// Check if swiper is already initialized to prevent duplicate initialization
						if (elem.swiper) {
							return
						}
						
						// Check if this is a complementary products slider
						const isComplementary = elem.closest('.complementary-products') !== null
						
						let mobileLayout = 1
						if (elem.dataset.mobileLayout) {
							mobileLayout = elem.dataset.mobileLayout
						}
						
						// For complementary products, show 1.5 products on mobile (base), 2 on larger screens
						const baseSlidesPerView = isComplementary ? 1.3 : mobileLayout
						const baseSlidesPerGroup = isComplementary ? 1 : 1
						
						let sliderConfig = {
							slidesPerView: baseSlidesPerView,
							slidesPerGroup: baseSlidesPerGroup,
							spaceBetween: 8,
							speed: 1000,
							navigation: {
								nextEl: elem.querySelector(
									'.product-recommendations__slider-nav .swiper-button-next',
								),
								prevEl: elem.querySelector(
									'.product-recommendations__slider-nav .swiper-button-prev',
								),
							},
						}
						
						// For complementary products, show 1.5 products on mobile, 2 on larger screens
						// For regular product recommendations, use responsive breakpoints
						if (isComplementary) {
							sliderConfig.breakpoints = {
								0: {
									slidesPerView: 1.3,
									slidesPerGroup: 1,
								},
								576: {
									slidesPerView: 2,
									slidesPerGroup: 1,
								},
							}
						} else {
							sliderConfig.breakpoints = {
								576: {
									slidesPerView: 2,
									slidesPerGroup: 2,
								},
								750: {
									slidesPerView: 3,
									slidesPerGroup: 3,
								},
								1200: {
									slidesPerView: 4,
									slidesPerGroup: 4,
								},
							}
						}
						
						let slider = new Swiper(elem, sliderConfig)
					})
				}

				const initSection = () => {
					const section = this

					this.resizeObserver = new ResizeObserver((entries) => {
						const [entry] = entries
						let top = calcTop(section)
						if (section.querySelector('.product-recommendations__slider-nav'))
							section.querySelector('.product-recommendations__slider-nav')
					})

					this.resizeObserver.observe(section)

					initSlider(section)
				}

				initSection()

				// Mark as loaded after successful fetch
				this.hasLoaded = true
				this.isLoading = false
			})
			.catch((e) => {
				console.error(e)
				// Reset loading flag on error so it can retry if needed
				this.isLoading = false
			})
	}

	disconnectedCallback() {
		// Clean up ResizeObserver to prevent memory leaks
		if (this.resizeObserver) {
			this.resizeObserver.disconnect()
			this.resizeObserver = null
		}
	}
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector('.section--has-overlay')
			const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')
						header.classList.add('color-background-1', 'color-background-3')
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-1', 'color-background-3')
					}
				} else {
					sections[0].classList.remove('not-margin')
					header.classList.remove('color-background-1', 'color-background-3')
				}
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:unload', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:reorder', function () {
		initHeaderOverlay()
	})
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)

	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)

		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}

	return formatString.replace(placeholderRegex, value)
}
